var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4997 49C21.4997 47.7114 22.5444 46.6667 23.833 46.6667H33.1664C34.455 46.6667 35.4997 47.7114 35.4997 49C35.4997 50.2887 34.455 51.3334 33.1664 51.3334H23.833C22.5444 51.3334 21.4997 50.2887 21.4997 49Z",
    fill: "#462AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9503 7.1173C20.0134 4.0542 24.1678 2.33337 28.4997 2.33337C32.8316 2.33337 36.986 4.0542 40.0491 7.1173C43.1122 10.1804 44.833 14.3348 44.833 18.6667C44.833 25.4629 46.5411 29.969 48.3316 32.8466L48.3593 32.8911C49.193 34.2309 49.852 35.29 50.2963 36.0609C50.519 36.4472 50.7218 36.8193 50.872 37.1501C50.947 37.3152 51.0308 37.5176 51.0964 37.7376C51.1508 37.9202 51.2544 38.3104 51.2155 38.7853C51.1894 39.1046 51.1243 39.65 50.8113 40.2134C50.4983 40.7769 50.0696 41.1203 49.8124 41.3111C49.2283 41.7443 48.5577 41.8434 48.3338 41.8764L48.3235 41.878C47.9796 41.9289 47.5892 41.9542 47.1955 41.9696C46.4132 42.0001 45.3302 42 43.9834 42H13.0161C11.6692 42 10.5862 42.0001 9.80394 41.9696C9.41018 41.9542 9.01987 41.9289 8.67591 41.878L8.66558 41.8764C8.44175 41.8434 7.77108 41.7443 7.18706 41.3111C6.92983 41.1203 6.50114 40.7769 6.18812 40.2134C5.8751 39.65 5.81001 39.1046 5.7839 38.7853C5.74506 38.3104 5.84866 37.9202 5.90304 37.7376C5.96859 37.5176 6.05245 37.3152 6.12742 37.1501C6.2776 36.8193 6.48045 36.4472 6.70309 36.0609C7.14743 35.29 7.80654 34.2307 8.6403 32.8908L8.66782 32.8466C10.4584 29.969 12.1664 25.4629 12.1664 18.6667C12.1664 14.3348 13.8872 10.1804 16.9503 7.1173Z",
    fill: "#462AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification-bell.06c35fe6b8995b883b86aee2375a2f39.svg";
export { ForwardRef as ReactComponent };